<template>
  <div>
      <b-dropdown :text="$t('header.genres')" class="genre-menu" disabled>
      <b-dropdown-item v-for='genre in orderedGenres'
      :key='genre.id'
      :value='genre.name'
      class="text-center"
      :to="'/genre/'+ genre.id"
      >
      <template v-if="genre.icon">
            <i :class="['icon genre-icon h3', `icon-${genre.icon}`]"/>
          </template>
          <template v-else>
            <i class="icon genre-icon h3 icon-profile-game-controller-inactive" />
        </template>
        <span class="d-block">
        {{genre.name}}
        </span>
      </b-dropdown-item>
      </b-dropdown>
  </div>
</template>



<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex';
export default {
  name: 'GenresMenu',
  computed: {
    ...mapGetters({
      genres: 'productCatalog/genres'
    }),
    orderedGenres() {
      return this.genres.sort((a, b) => {
        return a.name - b.name
      });
    }
  },
  methods: {
    ...mapActions({
      loadGenres: 'productCatalog/loadGenres'
    })
  },
  created() {
    if (this.genres.length === 0) {
      this.loadGenres()
    }
  }
}
</script>